const ColorCount = ({ color, count }) => {
    const boxStyle = {
        backgroundColor: color, // Use inline styles for dynamic colors
    };
    return (
        count ? <div className="flex items-center space-x-[10px]">
            <div className="w-3 h-3 rounded" style={boxStyle}></div>
            <div className="text-[#373737] text-[14px] font-mont font-[600]">{count}</div>
        </div> : <div className="flex items-center space-x-[10px]">
            <div className="w-3 h-3 rounded" style={boxStyle}></div>
            <div className="text-[#373737] text-[14px] font-mont font-[600]">0</div>
        </div>
    );
};

export default ColorCount;
